import { render, staticRenderFns } from "./rosters.vue?vue&type=template&id=41626203&"
import script from "./rosters.vue?vue&type=script&lang=js&"
export * from "./rosters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "rosters.vue"
export default component.exports